var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllamar = function SvgIllamar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none",
    viewBox: "0 0 30 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.662 1.995A2.336 2.336 0 0 0 6.884.636L1.728 2.042A2.35 2.35 0 0 0 0 4.304c0 14.495 11.753 26.249 26.249 26.249a2.35 2.35 0 0 0 2.262-1.729l1.406-5.156a2.336 2.336 0 0 0-1.36-2.777l-5.624-2.344a2.34 2.34 0 0 0-2.713.68l-2.367 2.889A19.8 19.8 0 0 1 8.437 12.7l2.889-2.361a2.34 2.34 0 0 0 .68-2.713L9.661 2.001z"
  })));
};
export default SvgIllamar;